<div tooltip data-popover="{{tooltip}}" [popover]="tooltip" triggers="hover" containerClass="custom-popover">
    <app-icon [glyph]="glyph" [badge]="badge" [classList]="class" [scale]="scale" [radio]="radio" [large]="large"
        [border]="border" [complete]="complete" [alt]="alt" [disabled]="disabled" name="{{name}}">
    </app-icon>
</div>
